import {
    FETCH_GENERAL_DETAILS_REQUEST,
    FETCH_GENERAL_DETAILS_SUCCESS,
    FETCH_GENERAL_DETAILS_FAILURE,
} from './vdc-instance.action';

const initialState = {
    generalDetails: null,
    loading: false,
    error: null,
    courseInstanceID: null as number | null,
};

export const viewDeployedCourseInstanceReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_GENERAL_DETAILS_REQUEST:
            return { ...state, loading: true, error: null, courseInstanceID: Number(action.payload) };
        case FETCH_GENERAL_DETAILS_SUCCESS:
            return { ...state, loading: false, generalDetails: action.payload, error: null };
        case FETCH_GENERAL_DETAILS_FAILURE:
            return { ...state, loading: false, error: action.payload, generalDetails: null };
        default:
            return state;
    }
};

export default viewDeployedCourseInstanceReducer;
